import { Star } from "lucide-react"

function MenuSection({ title, items, highlight = false, color = "green" }) {
  const getBgColor = () => {
    if (color === "black") return "bg-gray-900"
    return "bg-green-700"
  }

  return (
    <div className="bg-white rounded-lg shadow-lg overflow-hidden">
      <div className={`${getBgColor()} text-white py-3 px-4`}>
        <h2 className="text-2xl font-bold text-center">{title}</h2>
      </div>
      <div className="p-4">
        <ul className="space-y-3">
          {items.map((item, index) => (
            <li key={index} className="flex justify-between items-start">
              <div className="flex-1">
                <div className="flex items-center">
                  <span className="font-medium">{item.name}</span>
                  {item.isSpecial && <Star className="w-4 h-4 ml-1 text-red-500" fill="currentColor" />}
                </div>
                {item.description && <p className="text-sm text-gray-600 mt-1">{item.description}</p>}
              </div>
              <span className="font-bold text-amber-800 ml-4">{item.price}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

export default MenuSection
